module.exports = __webpack_public_path__ + "img/cosmetology.47c1956d.png";